const handleGithub = 'rodolfomarriel'
// const handleTwitter = 'rodolfomarriel'
const handleInstagram = 'rodmarriel'
const handleLinkedin = 'rodolfo-marriel-a8876286'

const links = [
  {
    label: "Github",
    target: "_blank",
    url: `https://github.com/${handleGithub}`,
  },
  // {
  //   label: "Twitter",
  //   url: `https://twitter.com/${handle}`,
  // },
  {
    label: "Instagram",
    target: "_blank",
    url: `https://www.instagram.com/${handleInstagram}`,
  },
  {
    label: "Linkedin",
    target: "_blank",
    url: `https://www.linkedin.com/in/${handleLinkedin}`,
  },
  {
    label: "Blog",
    target: "_blank",
    url: `https://blog.rodolfomarriel.me/`,
  },
]

export default links
